<template>
  <div class="items-center flex-1 px-6 text-primary-light-7">
    <nav class="inline-flex space-x-8 leading-[calc(var(--nav-bar-height)-2px)]">
      <span
        v-for="menu in topNav"
        :key="menu.menuId"
        class="nav-link"
        :class="{ 'is-active': activeNav === menu.path }"
        @click="activeNav = menu.path"
      >
        {{ menu.meta.title }}
      </span>
    </nav>
  </div>
</template>
<script lang="ts" setup>
const routerStore = useRouterStore();
const route = useRoute();

const topNav = computed(() => routerStore.sysRouter || []);

function getRoutePrefix(path: string) {
  const parts = path?.split('/')?.filter(Boolean) || [];
  return parts?.length > 0 ? '/' + parts[0] : '/';
}

// 当前激活的顶级菜单
const activeNav = ref(getRoutePrefix(route.path));

/**
 * 判断是否为白名单路由
 */
function isWhiteListRoute(path: string): boolean {
  return routerStore.whiteListOnTopNavToggle?.some((whitePath) => path.startsWith(whitePath)) || false;
}

/**
 * 根据当前路由路径更新顶级菜单状态
 */
function updateMenuByPath(currentPath: string) {
  // 白名单路由：不更新顶级菜单，保持当前状态
  if (isWhiteListRoute(currentPath)) {
    return;
  }

  // 非白名单路由：根据路径前缀更新顶级菜单
  const routePrefix = getRoutePrefix(currentPath);
  activeNav.value = routePrefix;
  routerStore.setCurrentMenu(routePrefix);
}

// 监听路由变化，自动更新顶级菜单状态
watch(
  () => route.path,
  (newPath) => {
    updateMenuByPath(newPath);
  },
  { immediate: true },
);

watch(
  () => activeNav.value,
  (newNav) => {
    routerStore.setCurrentMenu(newNav);
  },
  { immediate: true },
);
</script>
<style lang="scss" scoped>
.nav-link {
  cursor: pointer;
  font-size: large;

  &:hover {
    color: #fff;
  }

  &.is-active {
    border-bottom: 2px solid #fff;
    color: #fff;
  }
}
</style>
